import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sendFormspree } from '../../utils/formspree';
import './style.css';

const BookingModal = ({ selectedPackage, onClose }) => {
  const { t } = useTranslation('booking');

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    package: selectedPackage || '',
    preferredDates: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError('');

    try {
      await sendFormspree({
        source: 'Booking Modal',
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        package: formData.package,
        preferredDates: formData.preferredDates,
        message: formData.message,
      });
      setSubmitSuccess(true);
    } catch {
      setSubmitError(t('error'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="booking-modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="booking-modal">
        <div className="modal-header">
          <h2>{t('title')}</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        {submitSuccess ? (
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h3>{t('success.title')}</h3>
            <p>{t('success.desc')}</p>
            <button className="button" onClick={onClose}>
              {t('success.close')}
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="booking-form">
            <div className="form-group">
              <label>{t('fields.name.label')}</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder={t('fields.name.placeholder')}
                required
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>{t('fields.email.label')}</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder={t('fields.email.placeholder')}
                  required
                />
              </div>
              <div className="form-group">
                <label>{t('fields.phone.label')}</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder={t('fields.phone.placeholder')}
                />
              </div>
            </div>

            <div className="form-group">
              <label>{t('fields.package.label')}</label>
              <input
                type="text"
                name="package"
                value={formData.package}
                onChange={handleInputChange}
                placeholder={t('fields.package.placeholder')}
              />
            </div>

            <div className="form-group">
              <label>{t('fields.dates.label')}</label>
              <textarea
                name="preferredDates"
                value={formData.preferredDates}
                onChange={handleInputChange}
                placeholder={t('fields.dates.placeholder')}
                required
                rows="3"
              />
              <p className="hint-text">{t('fields.dates.hint')}</p>
            </div>

            <div className="form-group">
              <label>{t('fields.message.label')}</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder={t('fields.message.placeholder')}
                rows="4"
              />
            </div>

            <div className="form-actions">
              <button
                type="submit"
                className={`button ${isSubmitting ? 'loading' : ''}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? t('submitting') : t('submit')}
              </button>
            </div>
            {submitError && <p className="error-text">{submitError}</p>}

            <div className="form-footer">
              <p>{t('footer.disclaimer')}</p>
              <p>{t('footer.security')}</p>
              <p>
                {t('footer.whatsapp')}{' '}
                <a href="https://wa.me/358468130887">+358 46 813 0887</a>
              </p>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default BookingModal;
